import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.expenses')
  .factory('$expense', ExpenseObjectFactory);

/* @ngInject */
function ExpenseObjectFactory($bringozFactory: $bringozFactory,
                              ExpensesApi: BringozApi, Expenses_DS: DataStoreConfig) {

  function $expense(id: string) {
    return $bringozFactory(id, ExpensesApi, Expenses_DS);
  }

  return $expense;
}
